import client from "./authApi";

const BASE = "/api/sermons-ia";

export const sermonsApi = {
  list: ({ status } = {}) =>
    client
      .get(BASE, { params: status ? { status } : {} })
      .then((r) => r.data),

  get: (id) => client.get(`${BASE}/${id}`).then((r) => r.data),

  generate: (payload) =>
    client
      .post(`${BASE}/generate`, payload, { timeout: 180_000 })
      .then((r) => r.data),

  update: (id, payload) =>
    client.put(`${BASE}/${id}`, payload).then((r) => r.data),

  remove: (id) => client.delete(`${BASE}/${id}`).then((r) => r.data),
};
